import { useEffect, useState } from 'react';
import { getAuto, getSparky, StepFilterCar } from '@entities/Filter';
import { useAppSelector } from '@redux/hooks';

interface ReturnTypes {
  step: StepFilterCar;
}

export const useGetAdditionalFilterStep = (): ReturnTypes => {
  const { mark, model, year, modification } = useAppSelector(getAuto);
  const sparky = useAppSelector(getSparky);
  const [step, setStep] = useState<StepFilterCar | null>(sparky?.length ? StepFilterCar.stepFour : null);

  const handlerSetStep = () => {
    setStep(
      mark && !model && !year && !modification
        ? StepFilterCar.stepOne
        : mark && model && !year && !modification
          ? StepFilterCar.stepTwo
          : mark && model && year && !modification
            ? StepFilterCar.stepThree
            : mark && model && year && modification
              ? StepFilterCar.stepFour
              : null,
    );
  };

  useEffect(() => {
    handlerSetStep();
  }, [mark, model, year, modification]);

  return {
    step,
  };
};
